// Utility functions required by Dawn cart drawer
// Add this file to your theme before cart.js and cart-drawer.js load

// Debounce function
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Fetch configuration
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

// Focus trap utilities
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  document.addEventListener('keydown', onKeyUpEscape);
  document.addEventListener('keydown', trapFocusHandlers.focusout);
  document.addEventListener('keydown', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }

  function focusin(event) {
    if (event.code.toUpperCase() !== 'TAB') return;

    if (elements.length === 1) {
      event.preventDefault();
      return;
    }

    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  }

  function focusout() {
    const activeElement = document.activeElement;
    if (!container.contains(activeElement)) {
      elementToFocus.focus();
    }
  }

  trapFocusHandlers.focusin = focusin;
  trapFocusHandlers.focusout = focusout;
}

const trapFocusHandlers = {};

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('keydown', onKeyUpEscape);
  if (trapFocusHandlers.focusout) document.removeEventListener('keydown', trapFocusHandlers.focusout);
  if (trapFocusHandlers.focusin) document.removeEventListener('keydown', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Pub/Sub system
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

// Shopify routes (make sure these exist)
if (typeof routes === 'undefined') {
  window.routes = {
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    cart_url: '/cart',
    predictive_search_url: '/search/suggest'
  };
}

// Debounce timer constant
const ON_CHANGE_DEBOUNCE_TIMER = 300;

// Cart strings for error messages
if (typeof window.cartStrings === 'undefined') {
  window.cartStrings = {
    error: 'There was an error while updating your cart. Please try again.',
    quantityError: 'You can only add [quantity] of this item to your cart.'
  };
}

// Quick order list strings (if needed)
if (typeof window.quickOrderListStrings === 'undefined') {
  window.quickOrderListStrings = {
    min_error: 'Minimum quantity is [min]',
    max_error: 'Maximum quantity is [max]',
    step_error: 'Quantity must be in increments of [step]'
  };
}

console.log('✅ Cart utilities loaded');
